import { cva, } from 'class-variance-authority';

export { default as Select, } from './Select.vue';
export { default as SelectContent, } from './SelectContent.vue';
export { default as SelectGroup, } from './SelectGroup.vue';
export { default as SelectItem, } from './SelectItem.vue';
export { default as SelectItemText, } from './SelectItemText.vue';
export { default as SelectLabel, } from './SelectLabel.vue';
export { default as SelectScrollDownButton, } from './SelectScrollDownButton.vue';
export { default as SelectScrollUpButton, } from './SelectScrollUpButton.vue';
export { default as SelectSeparator, } from './SelectSeparator.vue';
export { default as SelectTrigger, } from './SelectTrigger.vue';
export { default as SelectValue, } from './SelectValue.vue';

export const selectTriggerVariants = cva(
  'flex relative w-full items-center justify-between rounded-md border bg-background px-3 py-2 text-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate text-start',
  {
    variants: {
      intent: {
        default: 'text-black pl-3 border rounded shadow-s m bg-white border-gray-300 focus:border-primary-140',
        ceTracker: 'pl-3 pr-8 h-12 border rounded text-primary-140 border-gray-300 font-bold h4 bg-white focus:border-primary-140',
        editProfile: 'border rounded shadow-sm border-gray-300 pl-3 pr-8 py-2 text-black bg-white focus:border-primary-140 font-normal',
        clientForm: 'block pl-3 pr-8 py-2 text-gray-400 border text-sm rounded border-gray-200 bg-white focus:border-primary-140',
        signup: 'pl-3 pr-8 py-4 text-black h4 border rounded border-gray-200 font-bold h4 bg-white focus:border-primary-140',
        checkout: 'border rounded shadow-sm border-gray-300 pl-3 pr-8 py-2 text-sm text-black bg-white focus:border-primary-140',
        courseEnrollment: 'border rounded shadow-sm border-gray-300 block pl-2 pr-8 py-1 text-sm font-bold text-black bg-white focus:border-primary-140',
        home: 'block pl-3 pr-8 py-4 text-text-secondary border-none font-bold h4 bg-white focus:border-primary-140 ',
        course: 'block pl-3 pr-8 py-3 text-text-secondary border border-matte-gray font-bold h4 bg-white focus:border-primary-140 ',
        courseMobile: 'flex items-center justify-between pl-3 pr-12 py-2 text-text-secondary border-2 border-matte-gray font-bold text-sm overflow-hidden bg-white focus:border-primary-140',
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900',
        nav: 'p-0 text-black',
        core100: 'text-pink border rounded border-pink py-2 font-bold text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const selectIconVariants = cva(
  'absolute flex items-center px-3 right-0', {
    variants: {
      intent: {
        default: 'text-black',
        ceTracker: 'text-text-secondary',
        courseMobile: 'text-text-secondary top-1/2 transform -translate-y-1/2 pl-4',
    },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const selectItemVariants = cva(
  'relative flex w-full justify-center cursor-default select-none items-center rounded-sm p-1.5 text-sm outline-none hover:bg-ghost focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
  {
    variants: {
      intent: {
        default: 'text-black pl-3 border rounded shadow-sm bg-white border-gray-300 focus:border-primary-140',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
